import { Row, Typography } from 'antd';
import styled from 'styled-components';

import { Title as TitleComponent } from '@atom/typography/typography';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  max-height: calc(100dvh - 32px);
`;

export const Title = styled(TitleComponent).attrs((props) => ({
  level: 2,
  color: props.theme.Title.colorSignUpTitle,
}))`
  padding-top: 24px;
`;

export const Description = styled(Typography.Paragraph)`
  color: ${(props) => props.theme.Title.colorSignUpDescription};
`;

export const BodyWrapper = styled(Row)`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 16px;
  width: 100%;
`;

export const Footer = styled.div`
  width: 320px;
  padding-top: 8px;
`;
